import React from 'react';
import { Link } from 'react-router-dom';
import AppSubmenu from './AppSubmenu';
import { perfil } from '../';

const AppMenu = props => {
    const fotoPerfil = props.usuario.foto && props.usuario.foto !== "0" ? props.usuario.foto : perfil;

    function logouf() {
        localStorage.clear();
        window.location.href = props.login;
    }

    function home() {
        history.push('/');
    }

    return React.createElement(
        'div',
        { className: 'layout-sidebar', onClick: props.onMenuClick },
        React.createElement(
            Link,
            { to: '/', className: 'logo' },
            React.createElement('img', { id: 'app-logo', className: 'logo-image', src: props.logo, alt: 'B\xFAssola do Investidor', onClick: () => home() })
        ),
        React.createElement(
            'div',
            { className: 'layout-menu-container' },
            React.createElement(
                'nav',
                { className: 'perfil-menu' },
                React.createElement(
                    'ul',
                    { className: 'profile-menu fade-in-up' },
                    props.topmenu ? props.topmenu : React.createElement(
                        'span',
                        null,
                        React.createElement(
                            'li',
                            null,
                            React.createElement(
                                'button',
                                { onClick: () => logouf(), type: 'button', className: 'p-link' },
                                React.createElement('i', { className: 'pi pi-power-off' }),
                                'Sair'
                            )
                        )
                    )
                )
            ),
            React.createElement(AppSubmenu, { items: props.model, menuMode: props.menuMode, parentMenuItemActive: true, menuActive: props.active, mobileMenuActive: props.mobileMenuActive, root: true, onMenuitemClick: props.onMenuitemClick, onRootMenuitemClick: props.onRootMenuitemClick })
        )
    );
};

export default AppMenu;